// Module
var code = "<div colorpicker=\"hex\" ng-model=\"vm.model\" colorpicker-fixed-position=\"true\" class=\"wt-color-picker\" ng-class=\"{'sm': vm.small, 'disabled': vm.disabled}\" colorpicker-position=\"{{vm.position||'top'}}\" ng-style=\"{'background-color': vm.disabled ? null : vm.model}\" colorpicker-with-input=\"true\"> </div>";
// Exports
module.exports = code;